import React from 'react';

/**
 * ArcheLogo — ARCHE Engineering Solutions brand logo.
 * Uses the official brand logo image (PNG with transparency).
 *
 * The logo contains the full brand system: AE monogram + ARCHE wordmark
 * + "ENGINEERING SOLUTIONS" + "ENGINEERING • DESIGN • MANUFACTURING" tagline.
 *
 * Sizes are calibrated for prominent brand presence in header and footer.
 */
export default function ArcheLogo({
  variant = 'light',
  size = 'md',
  className = ''
}) {
  const widthMap = {
    sm: 240,
    md: 340,
    lg: 480,
    xl: 640
  };
  const w = widthMap[size];

  // Subtle drop-shadow for depth on dark backgrounds; no color filter needed since
  // the artwork is already white on transparent.
  const filter =
    variant === 'light'
      ? 'drop-shadow(0 2px 12px rgba(0,0,0,0.35))'
      : 'none';

  return (
    <div className={`inline-block ${className}`} aria-label="ARCHE Engineering Solutions">
      <img
        src="/arche-brand-logo.png"
        alt="ARCHE Engineering Solutions"
        style={{
          width: `${w}px`,
          height: 'auto',
          display: 'block',
          filter
        }}
      />
    </div>
  );
}
